import { defineStore } from 'pinia';
import { api } from "boot/axios";
import { nextTick } from 'vue'

export const useResultPageStore = defineStore('resultPageStore', {
  state: () => ({
    sesId: null,
    currentPage: null,
    currentMenu: null,
    currentPageId: null,
    currentPath: null,
    adminMode: false,
    mandantId: null,
    addMandantIdToPath: true,
    docuId: null,
    addDocuIdToPath: true,
    recentSearches: [],

    settings: {
      data: true,
      loggedIn: false,
      loaded: false,
      project_name: "",
      project_url: "",
      project_description: "",
      project_welcome_msg: "",
      project_path: "",

      // below settings are only retrieved with access
      url: "",
      model: "",
      accesstoken: "",
      system_prompt: "",
      ask_prompt: "",
      ask_temperature: 1,
      summary_prompt: "",
      summary_temperature: 1,
      public_access: true,
      public_password: "",
      username: "",
      password: ""
    }
  }),
  getters: {

    // currentPageId() {
    //   return this.currentPage?.id;
    // }
  },
  actions: {
    increaseViewCount(id) {
      if (!this.currentPageId || id != this.currentPageId)
        return;
      return api
        .post(this.mandantId + '/' + this.docuId + "/pages/" + id + '/view')
        .catch(() => { });
    },
    setSettings(data) {
      if (data) {

        this.settings.loggedIn = data.loggedIn;
        this.settings.isNew = data.isNew;
        this.settings.loaded = true;
        this.settings.project_name = data.project_name;
        this.settings.project_url = data.project_url;
        this.settings.project_description = data.project_description;
        this.settings.project_welcome_msg = data.project_welcome_msg;
        this.settings.project_path = data.project_path;

        this.settings.url = data.url;
        this.settings.accesstoken = data.accesstoken;
        this.settings.model = data.model;

        this.settings.system_prompt = data.system_prompt;

        this.settings.ask_prompt = data.ask_prompt;
        this.settings.ask_temperature = data.ask_temperature;

        this.settings.summary_prompt = data.summary_prompt;
        this.settings.summary_temperature = data.summary_temperature;

        this.settings.public_access = data.public_access;
        this.settings.public_password = data.public_password;
      }
    },
    loadHistory() {
      return api
        .get(
          this.mandantId + '/' + this.docuId + "/history"
        );
    },
    loadSettings() {
      return api
        .get(
          this.mandantId + '/' + this.docuId + "/settings",
          this.sesId ? {
            params: {
              ses: this.sesId
            }
          } : undefined
        )
        .then((r) => {

          if (r.data) {
            return Promise.resolve(r.data);
          }
          return Promise.reject();
        })
        .catch(() => { return Promise.reject() }).then(this.setSettings);
    },
    saveSettings() {
      if (!this.sesId)
        return Promise.reject()
      return api
        .post(this.mandantId + '/' + this.docuId + "/settings", this.settings, {
          params: {
            ses: this.sesId
          }
        })
        .then(() => {
          this.settings.isNew = false;
        })
        .catch(() => { });
    },
    deleteAsk(id) {
      return api
        .delete(
          this.mandantId + '/' + this.docuId + "/questions/" + id
        )
        .then(() => {
          this.currentPage.questions = this.currentPage.questions.filter(q => q.id != id);
        })
        .catch(() => { });
    },
    ask(question) {
      let data = null;
      if (question.id)
        data = {
          questionId: question.id
        }
      else {
        data = {
          question: question.name
        }
      }

      return api
        .post(
          this.mandantId + '/' + this.docuId + "/pages/" + this.currentPageId + '/questions',
          data
        )
        .then((r) => {

          if (r.data) {
            this.currentPage.questions[this.currentPage.questions.indexOf(question)].text = r.data.text;
            this.currentPage.questions[this.currentPage.questions.indexOf(question)].loading = false;
            this.currentPage.questions[this.currentPage.questions.indexOf(question)].id = r.data.id;
            return Promise.resolve(r.data);
          }

          return Promise.reject(null);
        })
        .catch(() => { });
    },
    search(term) {
      return api
        .post(
          this.mandantId + '/' + this.docuId + "/search", { term: term }
        )
        .then((r) => {

          if (r.data) {
            const searchResults = {
              exact: r.data.exact.map((d) => {
                return {
                  id: d._id,
                  parentDoc: this.currentMenu.find(c => c.id == d._source.parent),
                  parent: d._source.parent,
                  type: d._source.type,
                  name: d._source.name,
                  nodeType: d._source.nodeType,
                  content: [d.highlight.summary, d.highlight.text].filter(f => f && f.length).join('...')
                }
              }),
              wildcard: r.data.wildcard.map((d) => {
                return {
                  id: d._id,
                  parentDoc: this.currentMenu.find(c => c.id == d._source.parent),
                  parent: d._source.parent,
                  type: d._source.type,
                  name: d._source.name,
                  nodeType: d._source.nodeType,
                  content: [d.highlight.summary, d.highlight.text].filter(f => f && f.length).join('...')
                }
              }),
              fuzzy: r.data.fuzzy.map((d) => {
                return {
                  id: d._id,
                  parentDoc: this.currentMenu.find(c => c.id == d._source.parent),
                  parent: d._source.parent,
                  type: d._source.type,
                  name: d._source.name,
                  nodeType: d._source.nodeType,
                  content: [d.highlight.summary, d.highlight.text].filter(f => f && f.length).join('...')
                }
              }),

              match: r.data.match.map((d) => {
                return {
                  id: d._id,
                  parentDoc: this.currentMenu.find(c => c.id == d._source.parent),
                  parent: d._source.parent,
                  type: d._source.type,
                  name: d._source.name,
                  nodeType: d._source.nodeType,
                  content: [d.highlight.summary, d.highlight.text].filter(f => f && f.length).join('...')
                }
              })
            }
            var count = searchResults.exact.length + searchResults.wildcard.length + searchResults.fuzzy.length + searchResults.match.length;
            if (count) {
              var key = term.trim().toLowerCase();
              var exiting = this.recentSearches.find(s => s.key == key);
              if (exiting)
                exiting.count = count;
              else
                this.recentSearches.push({
                  key: key,
                  term: term,
                  count: count
                })
            }
            return Promise.resolve(searchResults);
          }
          return Promise.reject();
        })
        .catch(() => { });
    },
    loadQuestions(tempPage) {
      tempPage.questions = [];
      return api
        .get(
          this.mandantId + '/' + this.docuId + "/pages/" + tempPage.id + '/questions'
        )
        .then((r) => {

          if (r.data) {

            tempPage.questions = r.data.map((d) => {
              return {
                id: d._id,
                target: '#' + d._id,
                name: d._source.name,
                text: d._source.text,
                nodeType: 'q',
                parent: tempPage.Id
              };
            })


            tempPage.children.push({
              target: '#' + c.id,
              name: 'Questions',
              nodeType: 'q',
              children: tempPage.questions
            });


            //   this.currentPage.children.push({
            //     id: 'questions',
            //     nodeType: 's',
            //     name: 'Questions',
            //     parent: this.currentPageId,
            //     children: this.currentPage.questions
            //   });
          }

          return Promise.resolve(tempPage);
        })
        .catch(() => { return Promise.resolve(tempPage); });
    },
    loadReferenes(tempPage) {
      tempPage.references = [];
      return api
        .get(
          this.mandantId + '/' + this.docuId + "/pages/" + tempPage.id + '/references'
        )
        .then((r) => {

          if (r.data) {

            tempPage.references = r.data.map((d) => {
              return {
                id: d._id,
                name: d._source.name,
                target: d._source.pageId
                // text: d._source.text
              };
            })
          }

          return Promise.resolve(tempPage);

        })
        .catch(() => { return Promise.resolve(tempPage); });
    },
    loadMenu(pageId) {
      this.currentMenu = [];
      return api
        .get(
          this.mandantId + '/' + this.docuId + "/pages"
        )
        .then((r) => {

          if (r.data) {
            let tempMenu = r.data.map((d) => {
              return {
                id: d._id,
                path: d._source.path,
                name: d._source.name,
                icon: d._source.icon,
                parent: d._source.parent,
                number: d._source.number,
                summary: d._source.summary,
                nodeType: d._source.nodeType ?? 'c',
                expanded: !d._source.parent,
                view_counter: d._source.view_counter ?? 0
              };
            });

            tempMenu = tempMenu.map((m) => {
              m.children = tempMenu.filter((s) => s.parent == m.id);
              return m;
            });

            // tempMenu = tempMenu.filter((m) => !m.parent);
            this.currentMenu = tempMenu;
            if (pageId)
              return this.load(pageId)
          }

        })
        .catch(() => { });
    },
    meta() {
      return {
        title: [this.settings.project_name,
        this.currentPage?.parentDoc?.name,
        this.currentPage?.name
        ].filter(f => !!f).join(' | ')
      };
    },

    getParents(page) {
      //  (page.nodeType == 's' || page.nodeType == 'q'
      var parents = [];
      while (page) {
        if (page.path) {
          // Check if the current node has an ID
          parents.push(page.path);
        } else if (page.id) {
          // Check if the current node has an ID
          parents.push(page.id);
        }
        page = this.currentMenu.find((i) => i.id == page.parent); // Move to the next parent
      }
      return parents.reverse();
    },
    getParentsIds(page) {
      var parents = [];
      while (page) {
        if (page.parent) {
          // Check if the current node has an ID
          parents.push(page.parent);
        } else if (page.id) {
          // Check if the current node has an ID
          parents.push(page.id);
        }
        page = this.currentMenu.find((i) => i.id == page.parent); // Move to the next parent
      }
      function onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
      }
      return parents.reverse().filter(onlyUnique);
    },
    getSearchPath(search) {
      var path = (this.addMandantIdToPath ? '/' + this.mandantId : '')
        + (this.addDocuIdToPath ? '/' + this.docuId : '');

      if (!this.addMandantIdToPath)
        path = path.replace(this.mandantId + '/', '');
      if (!this.addDocuIdToPath)
        path = path.replace('/' + this.docuId, '');

      path +=
        "/-/search/" +
        search;
      return path;
    },
    getPath(page, withHash = false) {
      var path = (this.addMandantIdToPath ? '/' + this.mandantId : '')
        + (this.addDocuIdToPath ? '/' + this.docuId : '');

      if (!this.addMandantIdToPath)
        path = path.replace(this.mandantId + '/', '');
      if (!this.addDocuIdToPath)
        path = path.replace('/' + this.docuId, '');

      if (!page) {
        if (!path)
          path = '/';
        return path;
      }
      var parents = this.getParents(page);
      var page = parents.pop();
      if (withHash)
        page = '#' + page;
      else
        page = '/' + page;

      path += '/' + parents.join('/') + page;

      path = path.replaceAll('//', '/');
      return path;
    },
    load(path) {
      var path = (this.addMandantIdToPath ? '/' + this.mandantId : '')
        + (this.addDocuIdToPath ? '/' + this.docuId : '') + '/' + path.join('/');

      if (!this.addMandantIdToPath)
        path = path.replace(this.mandantId + '/', '');
      if (!this.addDocuIdToPath)
        path = path.replace('/' + this.docuId, '');


      if (!this.currentMenu || !this.currentMenu.length) {
        return this.loadMenu(path);
      }
      var realId = path.split('/').pop();
      // this.loadMenu(path);
      var page = this.currentMenu.find(f => f.id == realId || this.getPath(f) == path);
      // when we not found the page by page we try to find it by realId
      // if (!page) {
      //   page = this.currentMenu.find(f =>
      //     f.id == realId);
      //   if (page)
      //     return Promise.resolve(this.getPath(page));
      //   else
      //     return Promise.reject();
      // }
      return api
        .get(
          this.mandantId + '/' + this.docuId + "/pages/" + page.id
        )
        .then((r) => {

          if (r.data) {

            const childs = page.children;

            const tempPage = {
              id: page.id,
              path: r.data.path,
              name: r.data.name,
              content: r.data.content,
              summary: r.data.summary,
              nodeType: r.data.nodeType ?? 'c',
              icon: r.data.icon,
              number: r.data.number,
              parent: r.data.parent ? r.data.parent : null,
              parentDoc: null,
              view_counter: r.data.view_counter ?? 0,
              children: [],
              references: [],
              attachments: [],
              questions: [],
              contentList: []
            };

            tempPage.children = childs;

            if (tempPage.parent) {
              tempPage.parentDoc = this.currentMenu.find(c => c.id == tempPage.parent);
            }
            if (tempPage.nodeType == 'c' && childs?.length) {

              tempPage.children = childs.filter(c => c.nodeType == 's');
              tempPage.children.forEach((c) => {
                c.target = '#' + c.id;
                api.get(
                  this.mandantId + '/' + this.docuId + "/pages/" + c.id)
                  .then((r) => {
                    if (r.data)
                      c.content = r.data.content;
                  });
              });
            }

            tempPage.parents = this.getParentsIds(tempPage);

            return Promise.resolve(tempPage);
          }
          return Promise.reject();
        })
        // .then(this.loadQuestions)
        .then(this.loadReferenes)
        .then((tempPage) => {
          this.currentPage = tempPage;
          this.currentPageId = tempPage.id;
          this.currentPath = this.getPath(this.currentPage)
          return Promise.resolve(this.currentPath);
        })
        .catch(() => {
          return Promise.reject();
        });

    },
  },
});
